export enum MessageToUserType {
  ConnectedTo = "connectedTo",
  DisconnectedFrom = "disconnectedFrom",
}

export interface MessageToUser {
  type: MessageToUserType;
  userIdentifier: string;
}

export class MessageToUserHelper {
  static fromFirebaseValue(
    value: Record<string, string> | null | undefined,
  ): MessageToUser | null {
    if (!value) {
      return null;
    }

    if (value.connectedTo) {
      return {
        type: MessageToUserType.ConnectedTo,
        userIdentifier: value.connectedTo,
      };
    }

    if (value.disconnectedFrom) {
      return {
        type: MessageToUserType.DisconnectedFrom,
        userIdentifier: value.disconnectedFrom,
      };
    }

    return null;
  }

  static toFirebaseValue(message: MessageToUser): Record<string, string> {
    if (message.type === MessageToUserType.ConnectedTo) {
      return { connectedTo: message.userIdentifier };
    } else {
      return { disconnectedFrom: message.userIdentifier };
    }
  }
}
